export default __webpack_public_path__ + "static/media/female-ectomorph.9fd11c2f.svg";